// extracted by mini-css-extract-plugin
module.exports = {"title":"ConsentItem_title__9UeNo","titleWithdrawn":"ConsentItem_titleWithdrawn__2ranK","date":"ConsentItem_date__3oSVy","container":"ConsentItem_container__2wqBK"};